import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts/AuthContext';
import { Lock, AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const [showSessionExpired, setShowSessionExpired] = useState(false);

  useEffect(() => {
    // Mostrar alerta si viene redirigido del dashboard
    if (location.state?.sessionExpired) {
      setShowSessionExpired(true);
    }
  }, [location]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (login(password)) {
      toast({
        title: 'Acceso concedido',
        description: 'Bienvenido al dashboard',
      });
      navigate('/dashboard');
    } else {
      toast({
        title: 'Error de acceso',
        description: 'Contraseña incorrecta',
        variant: 'destructive',
      });
      setPassword('');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <Card className="w-full max-w-md p-6">
        <div className="flex flex-col items-center space-y-6">
          <div className="p-3 rounded-full bg-primary/10">
            <Lock className="w-8 h-8 text-primary" />
          </div>
          
          {showSessionExpired && (
            <Alert variant="destructive">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>
                Tu sesión ha expirado. Por favor, inicia sesión nuevamente.
              </AlertDescription>
            </Alert>
          )}

          <div className="space-y-2 text-center">
            <h1 className="text-2xl font-bold">Acceso al Dashboard</h1>
            <p className="text-sm text-muted-foreground">
              Ingresa la contraseña de administrador
            </p>
          </div>

          <form onSubmit={handleSubmit} className="w-full space-y-4">
            <div className="space-y-2">
              <Input
                type="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <Button type="submit" className="w-full">
              Acceder
            </Button>
          </form>
        </div>
      </Card>
    </div>
  );
};

export default AdminLogin; 